var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-0 m-0 w-screen h-screen overflow-y-hidden",attrs:{"id":"app"}},[_c('vue-confirm-dialog'),_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c(_vm.layout,{tag:"component"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }